export default "__VITE_ASSET__39c6b370__"